<style scope>

</style>

<template>
    <div>
        <van-row style="padding-bottom: 47px">
            <van-nav-bar fixed left-arrow left-text="返回" title="房屋信息" @click-left="back">
                <van-icon name="plus" slot="right" />
            </van-nav-bar>
        </van-row>

        <van-row>
            <!--<van-search
                    v-model="value"
                    placeholder="请输入客户姓名搜索"
                    show-action
                    @search="onSearch"
            >
                <div slot="action" @click="onSearch">搜索</div>
            </van-search>-->
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad">
                <van-cell
                        style="padding: 20px"
                        v-for="item in list"
                        :key="item"
                        is-link
                        center>
                    <template>
                        <span slot="title">
                            张三{{item}}
                        </span>
                        <div slot="">
                            <span>广东省广州市天河区</span>
                        </div>
                    </template>
                </van-cell>
            </van-list>
        </van-row>
    </div>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'customer',
    props: {},
    computed: {},
    watch: {},
    data: function () {
      return {
        value: '',
        list: [],
        loading: false,
        finished: false,
        checked: false
      }
    },
    methods: {
      back () {
        this.$router.go(-1)
      },
      onSearch() {},
      onLoad() {
        // 异步更新数据
        setTimeout(() => {
          for (let i = 0; i < 10; i++) {
            this.list.push(this.list.length + 1);
          }
          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (this.list.length >= 40) {
            this.finished = true;
          }
        }, 500);
      }
    },
    mounted () {

    },
    destroyed () {

    }
  }
</script>
